export default "__VITE_ASSET__ypHsXFoh__"